<template>
  <div class="app-conf-tag-list-page">
    <div class="global-header-wrap">
      <div class="header-left">
        <div class="left-part">
          <span>标签Key</span>
          <div class="listSearch">
            <el-input
              v-model="searchKey"
              clearable
              @input="inputHandleSeach"
              @keyup.enter.native="search"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>状态</span>
          <div class="listSearch">
            <el-select
              v-model="searchStatus"
              @change="search"
              placeholder="全部"
              clearable
            >
              <el-option label="启用" :value="0"></el-option>
              <el-option label="禁用" :value="1"></el-option>
            </el-select>
          </div>
        </div>
        <div class="left-part">
          <span>排序字段</span>
          <div class="listSearch">
            <el-select
              v-model="sortBy"
              @change="handleSortChange"
              placeholder="请选择"
            >
              <el-option label="排序" value="sort"></el-option>
              <el-option label="创建时间" value="createdAt"></el-option>
            </el-select>
          </div>
        </div>
        <div class="left-part">
          <span>排序方向</span>
          <div class="listSearch">
            <el-button
              @click="toggleOrderBy"
              icon="el-icon-sort"
              size="small"
            >
              {{ orderBy === -1 ? '降序' : '升序' }}
            </el-button>
          </div>
        </div>
        <button class="global-button-style" @click="search()">
          {{ $t("commonMsg.search") }}
        </button>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'createAppConfTag' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />新增标签
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">标签总数：{{ total ? total : 0 }}</div>
      <div class="global-body-wrap">
        <AppTable
          :tableProps="tableProps"
          :tableData="tableData"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="paramsList.limit"
        :total="total"
        @pageNum="pageNum"
        @pageSize="pageSize"
      />
    </el-card>
  </div>
</template>

<script>
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";

export default {
  name: "appConfTag",
  components: {
    AppTable,
    Pagination,
  },
  computed: {
    tableProps() {
      let tableProps = [
        {
          prop: "key",
          label: "标签Key",
        },
        {
          prop: "name",
          label: "标签名称",
          formatter: (row) => {
            return row.name && row.name["zh-CN"]
              ? row.name["zh-CN"]
              : "-";
          },
        },
        {
          prop: "description",
          label: "描述",
          formatter: (row) => {
            return row.description && row.description["zh-CN"]
              ? row.description["zh-CN"]
              : "-";
          },
        },
        {
          prop: "color",
          label: "颜色",
          width: 100,
        },
        {
          prop: "sort",
          label: "排序",
          width: 80,
        },
        {
          prop: "status",
          label: "状态",
          width: 80,
          formatter: (row) => {
            return row.status === 0 ? "启用" : "禁用";
          },
        },
        {
          prop: "createdAt",
          label: "创建时间",
          width: 180,
        },
        {
          prop: "handle",
          label: "操作",
          width: 240,
          btn: [
            this.$t("commonMsg.edit"),
            "状态",
            this.$t("commonMsg.del"),
          ],
        },
      ];
      return tableProps;
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      searchKey: "",
      searchStatus: "",
      sortBy: "sort",
      orderBy: 1,
      paramsList: { limit: 20, page: 1, sortBy: "sort", orderBy: 1 },
      timer: null,
    };
  },
  methods: {
    async getAppConfTagList() {
      try {
        let res = await this.$http.getAppConfTagListAdmin(this.paramsList);
        this.total = res.data.count;
        this.tableData = res.data.results.map((item) => ({
          ...item,
          statusBtnText: item.status === 0 ? "禁用" : "启用",
        }));
      } catch (error) {
        console.error(error);
      }
    },

    search() {
      this.paramsList.page = 1;
      this.searchKey
        ? (this.paramsList.key = this.searchKey)
        : delete this.paramsList.key;
      this.searchStatus !== ""
        ? (this.paramsList.status = this.searchStatus)
        : delete this.paramsList.status;

      this.getAppConfTagList();
    },

    inputHandleSeach() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.search();
      }, 1000);
    },

    handleSortChange(value) {
      this.paramsList.sortBy = value;
      this.paramsList.page = 1;
      this.getAppConfTagList();
    },

    toggleOrderBy() {
      this.orderBy = this.orderBy === -1 ? 1 : -1;
      this.paramsList.orderBy = this.orderBy;
      this.paramsList.page = 1;
      this.getAppConfTagList();
    },

    async tableHandle(obj) {
      const row = obj.data.row;
      const type = obj.type;

      if (type === this.$t("commonMsg.edit")) {
        this.$router.push({
          name: "createAppConfTag",
          query: { id: row._id },
        });
      } else if (type === "状态") {
        const newStatus = row.status === 0 ? 1 : 0;
        const action = newStatus === 1 ? "禁用" : "启用";
        this.$confirm(`确定要${action}此标签吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          await this.toggleStatus(row._id, newStatus);
        });
      } else if (type === this.$t("commonMsg.del")) {
        this.$confirm("确定要删除此标签吗?删除后不可恢复！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          await this.deleteTag(row._id);
        });
      }
    },

    async toggleStatus(id, status) {
      try {
        await this.$http.toggleAppConfTagStatus(id, { status });
        this.getAppConfTagList();
        this.elMsg(status === 0 ? "启用成功" : "禁用成功", "success");
      } catch (error) {
        this.elMsg(status === 0 ? "启用失败" : "禁用失败", "error");
      }
    },

    async deleteTag(id) {
      try {
        await this.$http.deleteAppConfTag(id);
        this.getAppConfTagList();
        this.elMsg("删除成功", "success");
      } catch (error) {
        this.elMsg("删除失败", "error");
      }
    },

    pageNum(val) {
      this.paramsList.page = val;
      this.getAppConfTagList();
    },

    pageSize(size) {
      this.paramsList.limit = size;
      this.getAppConfTagList();
    },
  },
  mounted() {
    this.getAppConfTagList();
  },
};
</script>

<style lang="scss" scoped>
.global-header-wrap {
  padding: 10px 44px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.global-button-style {
  margin-top: 20px;
  margin-left: 0;
}
.app-conf-tag-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .app-table-container {
    flex: 1;
    overflow: hidden;
  }
  
  .global-body-wrap {
    height: calc(100vh - 280px);
    
    #table-wrap {
      height: 100%;
    }
  }
  
  .header-left {
    display: flex;
    align-items: flex-end;
  }
  .left-part {
    margin-right: 20px;
    .listSearch {
      .el-input {
        width: 180px;
        .search-icon {
          font-size: 22px;
          cursor: pointer;
        }
      }
      .el-select {
        width: 180px;
      }
    }
    > span {
      margin-right: 10px;
      font-size: 14px;
    }
    .global-button-style {
      margin: 0;
    }
  }
}
</style>
